import  { StockAll } from "../objects/StockAll"
import { listBrandsMemory, listItemsMemory, listProductsMemory } from "./Memory"

export const stockAllController = new StockAll()

export const CalculateStockAll = async () => {
    stockAllController.calculate(listItemsMemory,listProductsMemory,listBrandsMemory.length)
}
